<div class="stock-ag-table-actions">
  <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
    Actions <i class="flaticon-more ml-2"></i>
  </button>
  <mat-menu class="lum-mat-menu" #menu="matMenu">
    <button mat-menu-item [matMenuTriggerFor]="resetMenu"> Reset Baseline </button>
    <button mat-menu-item (click)="onConfirmResyncPending()">
      Resync Pending
    </button>
    <button mat-menu-item [matMenuTriggerFor]="exportMenu">Export</button>
  </mat-menu>
  <!-- Reset Baseline Submenu -->
  <mat-menu #resetMenu="matMenu">
    <ng-container *ngFor="let warehouse of warehouseOptions; trackBy: trackByValue">
      <button mat-menu-item (click)="$event.stopPropagation()">
        <mat-checkbox [(ngModel)]="warehouse.checked">{{
          warehouse.label
        }}</mat-checkbox>
      </button>
    </ng-container>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onConfirmResetBaseline()">
      <span>Reset Selected</span>
    </button>
  </mat-menu>
  <!-- Exports -->
  <mat-menu #exportMenu="matMenu">
    <button mat-menu-item (click)="onExportInventoryNumbers()">
      Inventory Numbers to CSV
    </button>
    <button mat-menu-item (click)="onExportInventoryKitNumber()">
      Inventory Kit Numbers to CSV
    </button>
  </mat-menu>
</div>
